import {Pipe, PipeTransform} from '@angular/core';
import {from, Observable} from 'rxjs';
import {FileInteractionsService} from '@services';

@Pipe({
  name: 'urlToBase64',
  standalone: true
})
export class UrlToBase64Pipe implements PipeTransform {

  constructor(
    private _fileInteractionsService: FileInteractionsService) {
  }

  transform(url: string): Observable<string> | null {
    if (!url) {
      return null
    }
    return from(this._fileInteractionsService.base64ImageFromUrl(url))
  }


}
